/* globals: booking_form_params */
import $ from 'jquery';

/**
 * Returns the hour offset between the client and the server.
 *
 * @param {*} referenceDate at which to compute offset.
 * @return {number} Number of hours between server and client.
 */
export function getClientServerTimezoneOffsetHrs( referenceDate ) {
	if ( ! booking_form_params.timezone_conversion ) {
		return 0;
	}
	const referenceTime = moment( referenceDate );
	const clientOffset = referenceTime.utcOffset();
	referenceTime.tz( booking_form_params.server_timezone );
	const serverOffset = referenceTime.utcOffset();
	return ( clientOffset - serverOffset ) / 60.0;
}
/**
 * Serialize a booking form for its AJAX requests.
 *
 * The form is posted nested in a single field, which double-encodes the "+" of a
 * time value's UTC offset as "%252B", and some host firewalls reject that. The
 * server ignores the offset, so it is dropped from the booking time fields.
 *
 * @param {jQuery} $form Booking form.
 * @return {string} Serialized form.
 */
export function serializeBookingForm( $form ) {
	return $form
		.serialize()
		.replace(
			/((?:^|&)(?:wc_bookings_field_start_date_time|start_time)=\d{4}-\d{2}-\d{2}T\d{2}%3A\d{2}%3A\d{2})%2B\d{4}(?=&|$)/g,
			'$1'
		);
}
export function displayError(
	errorMessage = booking_form_params.i18n_request_failed,
	after = '#wc-bookings-booking-form'
) {
	// Remove 'active' class from old notices.
	$( '.woocommerce-error.wc-bookings-notice' ).removeClass( 'active' );

	// Create a new error notice element.
	const errorMessageHTML = document.createElement( 'p' );
	errorMessageHTML.setAttribute(
		'class',
		'woocommerce-error wc-bookings-notice active'
	);
	errorMessageHTML.setAttribute( 'style', 'display: none;' );
	errorMessageHTML.textContent = errorMessage;
	$( errorMessageHTML ).insertAfter( after );

	// Show a new notice and hide old ones.
	$( '.woocommerce-error.wc-bookings-notice.active' ).slideDown( {
		complete() {
			$( '.woocommerce-error.wc-bookings-notice:not(.active)' ).slideUp();
		},
	} );
}
